import {
  createTheme,
  CssBaseline,
  PaletteMode,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material";
import { useSettings } from "@natklok/hooks/useSettings";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import { pathsWithLightMode } from "../config";
import theme, { getDesignTokens } from "../config/theme";

const MUIThemeWrapper: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const settings = useSettings();
  const [mode, setMode] = useState<PaletteMode>("dark");
  const location = useLocation();
  useEffect(() => {
    setMode("dark");
    for (const path of pathsWithLightMode) {
      if (location.pathname === path) {
        setMode("light");
        break;
      }
    }
  }, [location.pathname]);

  let muiTheme = useMemo(
    () => createTheme({ ...getDesignTokens(mode), ...theme(settings.age) }),
    [mode, settings.age]
  );
  muiTheme = responsiveFontSizes(muiTheme);
  return (
    <ThemeProvider theme={muiTheme}>
      {children}
      <CssBaseline />
    </ThemeProvider>
  );
};

export default MUIThemeWrapper;
